// extracted by mini-css-extract-plugin
module.exports = {"container":"AnimationFlask_container__InmNR","tube":"AnimationFlask_tube__Ws3BN","flask":"AnimationFlask_flask__38x2U"};